import { ApiData } from 'states/types'
import { NivosMessage } from 'types/nivos-message'

const Types = {
  SET: '@@message/SET',
  ADD: '@@message/ADD',
  UPDATE: '@@message/UPDATE',
  LOADING: '@@message/LOADING'
}

export type Payload = ApiData<NivosMessage>

export { Types }
